
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48","viewBox":"0 0 48 48"}},[_c('path',{attrs:{"d":"M37.826 32.092h-1.668l-.494-.49A16.209 16.209 0 108.128 20.011H2.893l7.176 7.233 7.177-7.233h-5.389a12.507 12.507 0 113.724 8.881l-2.641 2.641a16.183 16.183 0 0021.491 1.155l.569.565v1.663l7.3 7.288 2.8-2.8z"}}),_c('path',{attrs:{"d":"M25.571 20.514V13.35H22.12v8.954l7.671 4.55 1.684-2.834z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      